module.exports = __webpack_public_path__ + "media/npc_dota_hero_shredder.3f70d66d.webm";